<template>
  <div class="search-input-501 d-flex" @click.stop="">
    <transition name="wipe">
      <input ref="inputElement" v-if="showInput" @keyup.enter="search()" :placeholder="$t('nav.search_placeholder')" type="text" v-model.trim="words"
             class="search-input-501-input search-input-501-form-absolut-data" transition-style="in:wipe:right">
    </transition>
    <i @click="toggleInput" class="search-input-501-icon bi bi-search mx-2 text-muted"/>

  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "SearchInput501",
  data() {
    return {
      words: '',
      type: 'all',
      showInput: false, // برای کنترل نمایش اینپوت
    }
  },
  methods: {
    search() {
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    },
    toggleInput() {
      this.showInput = !this.showInput; // تغییر وضعیت نمایش اینپوت
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        if (this.showInput) {
          this.$refs.inputElement.setAttribute('transition-style', 'out:wipe:left');
          setTimeout(() => {
            this.showInput = false;
          }, 2500);
        }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
.search-input-501 {
  background: white;
}

.search-input-501 .search-input-501-input {
  width: 100%;
  background: transparent;
  border-radius: 15px;
  border: 1px solid gray;
}

@keyframes wipe-in-right {
  from {
    clip-path: inset(0 100% 0 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
}

[transition-style="in:wipe:right"] {
  animation: 0.5s cubic-bezier(.25, 1, .30, 1) wipe-in-right both;
}

@keyframes wipe-out-left {
  from {
    clip-path: inset(0 0 0 0);
  }
  to {
    clip-path: inset(0 100% 0 0);
  }
}

[transition-style="out:wipe:left"] {
  animation: 0.5s cubic-bezier(.25, 1, .30, 1) wipe-out-left both;
}

.search-input-501-icon {
  z-index: 100;
  position: relative;
  background-color: transparent;
  padding: 5px 15px 0 0;
  cursor: pointer; /* اضافه کردن نشانگر اشاره‌گر برای نمایش کلیک‌پذیری */
  font-size: 25px;
}

.search-input-501-form-absolut-data {
  width: 100%;
}

.search-input-501 input::placeholder {
  font-size: 14px;
  text-align: right;
  padding: 5px;
}

.search-input-501 input:focus-visible {
  outline: none;
}
</style>
